import FEATURE_LIST from "../../helpers/featuresList";
import Icon from "components/Elements/Icon/Icon";
import PRODUCT_LIST from "../../helpers/productList";
import useIsIsraelUser from "../MegaMenu/hooks/useIsIsraelUser";

import { ButtonAccessability } from "components/Elements/Button/Button";
import { LinkToNewTab } from "components/Elements/Link/Link";
import { memo } from "react";
import { useContent } from "contexts/contentContext/contentContext";

import styles from "./drawerFeaturesSection.module.scss";

interface FeaturesSectionI extends React.HTMLAttributes<HTMLDivElement> {
  setShowSection: React.Dispatch<
    React.SetStateAction<"features" | "for-businesses" | "">
  >;
  setShowHeaderDrawer: React.Dispatch<React.SetStateAction<boolean>>;
}

/**
 * DrawerFeaturesSection component represents the features section for the Drawer.
 * It shows when the user clicks on the "Features" main menu item.
 */

const DrawerFeaturesSection = (props: FeaturesSectionI) => {
  const { setShowSection, setShowHeaderDrawer, ...restProps } = props;
  const { getTextByKey, getDirection } = useContent();

  const isIsraelUser = useIsIsraelUser();

  const handleFeatureClick = (titleKey: string) => {
    // If the user is on the features page, scroll to the clicked feature
    if (window.location.pathname.includes("features")) {
      // Close header

      setShowHeaderDrawer(false);

      // Return to the main menu section
      setShowSection("");

      // Make page scrollable again
      document.body.classList.remove("fixed-position");

      // Find the element with the clicked feature title
      const element = document.getElementById(titleKey);

      if (element) {
        // Scroll to the element
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <div className={styles.wrapper} {...restProps}>
      <ButtonAccessability onClick={() => setShowSection("")}>
        <h3 className={styles.title}>
          <Icon
            name={getDirection() === "rtl" ? "arrow-right" : "arrow-left"}
            gray
          />
          {getTextByKey("features")}
        </h3>
      </ButtonAccessability>
      <ul>
        {FEATURE_LIST.map(({ titleKey, anchor, iconKey }) => (
          <li key={titleKey} onClick={() => handleFeatureClick(titleKey)}>
            {/*@ts-ignore*/}
            <LinkToNewTab page={`features#${anchor}`}>
              <Icon name={`mega-menu/${iconKey}`} blue large />
              <h4>{getTextByKey(titleKey)}</h4>
            </LinkToNewTab>
          </li>
        ))}
      </ul>
      <hr />
      <h3 className={`${styles.title} ${styles.productsTitle}`}>
        {getTextByKey("drawer-products-title")}
      </h3>
      <ul>
        {PRODUCT_LIST.filter((product) =>
          // Show JUMBOpay only for users from Israel
          product.name === PRODUCT_LIST[2].name ? isIsraelUser : true
        ).map(({ name }) => (
          <li key={name}>
            {/*@ts-ignore*/}
            <LinkToNewTab page={`products#${name}`}>
              <Icon name={`mega-menu/${name}`} large />
              <span>JUMBO{name}</span>
            </LinkToNewTab>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default memo(DrawerFeaturesSection);
